import type { Product, TraitsForContext } from '../types';

export const STANDARD_TO_PREMIUM_TRAIT_ELIGIBILITY: Partial<
	Record<Product, keyof TraitsForContext>
> = {
	jira: 'isEligibleForJswStandardToPremium',
	'jira-service-management': 'isEligibleForJsmStandardToPremium',
	'jira-product-discovery': 'isEligibleForJpdStandardToPremium',
	confluence: 'isEligibleForConfluenceStandardToPremium',
};
